import { Box, makeStyles } from '@material-ui/core';
import React from 'react';

interface Props {
  color?: string
}

const DOT_SIZE = 3;
const DOT_GAP = 4;
const ANIMATION_DURATION = '1.2s';
const opacities = [0.3, 0.6, 1];

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 4,
    minWidth: 20,
    height: 20,
  },
  dot: {
    width: DOT_SIZE,
    height: DOT_SIZE,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
    animation: `$reactSelectDot ${ANIMATION_DURATION} infinite ease-in-out`,
  },
  dotGap: { marginRight: DOT_GAP },
  '@keyframes reactSelectDot': {
    '0%, 80%, 100%': { transform: 'scale(1)', opacity: 0.3 },
    '40%': { transform: 'scale(1.35)', opacity: 1 },
  },
});

const ReactSelectLoadingDots: React.FC<Props> = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {opacities.map((opacity, index) => (
        <Box
          key={opacity}
          component="span"
          className={`${classes.dot} ${index !== opacities.length - 1 ? classes.dotGap : ''}`}
          style={{ opacity, animationDelay: `${index * 0.15}s` }}
        />
      ))}
    </Box>
  );
};
export default ReactSelectLoadingDots;
